export default __webpack_public_path__ + "static/media/longchamp24.df05932c.jpg";